// extracted by mini-css-extract-plugin
export var component = "EngagementTeaser-module--component--PUoYC";
export var description = "EngagementTeaser-module--description--bQTfx";
export var tintLight = "EngagementTeaser-module--tintLight--UMdxV";
export var tintMedium = "EngagementTeaser-module--tintMedium--1FRlj";
export var title = "EngagementTeaser-module--title--kQkcd";